import React from "react";
import { Button } from "@mui/material";
import "../../styles/ButtonComponet.css";

const ButtonComponet = ({
  children,
  onClick,
  disabled,
  className,
  sx,
  variant = null,
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`${className} ${
        variant === "contained"
          ? "contained-button-variant"
          : "text-button-variant"
      }`}
      sx={sx}
    >
      {children}
    </Button>
  );
};

export default ButtonComponet;
